import React from 'react';
import { useDispatch } from 'react-redux';
import { threadActions } from 'redux/actions';
import { initPendo } from 'util/pendo';

export function useInboxAccess(user) {
	const dispatch = useDispatch();

	const { inboxAccessList, customerIds } = user;

	React.useEffect(
		() => {
			// Initialize Pendo with user's metadata
			const customer = customerIds.find((c) => c.product === 'TextRecruit');
			if (customer) {
				initPendo(user, customer.role);
			}

			// Initialize user's enabled inboxes and unread counts
			inboxAccessList.forEach((inbox) => {
				const inboxType = inbox.accountType;
				dispatch(threadActions.getThreads({ pageNumber: 1, inboxType }));
				dispatch(threadActions.fetchThreadsWithUnreadMessages({ inboxType }));
			});
		},
		[user.inboxAccessList]
	);
}
